import { IColumns, readExcel } from './index';
import Excel from 'exceljs';
import {
  IAnswerInfo,
  IExamCheckAnswerCardBody,
} from '../../models/testCenter.model';

interface IAnswerExcelData {
  examSubjectCode: number;
  body: IExamCheckAnswerCardBody[];
}

interface IAnswerColumns {
  examTypeName?: string;
  examDiv?: string;
  examTestCode?: number;
}

export const generateAnswerColumns = ({
  examTypeName,
  examDiv,
  examTestCode,
}: IAnswerColumns): IColumns[] => {
  return [
    { header: '시험명', width: 10 },
    { header: examTypeName ?? '', width: 25 },
    { header: '시험유형', width: 15 },
    { header: examDiv ?? '', width: 10 },
    { header: '시험지코드(examCode)', width: 25 },
    { header: examTestCode?.toString() ?? '', width: 10 },
  ];
};

export const generateAnswerRows = (
  subjectName: string,
  examSubjectCode: number,
  answerInfos: IAnswerInfo[],
) => {
  const rows: any[] = [
    { 0: '과목명', 1: subjectName, 2: '시험 과목 코드', 3: examSubjectCode },
    { 0: '번호', 1: '퀴즈코드', 2: '학생답안' },
  ];
  for (let i = 0; i < answerInfos.length; i++) {
    rows.push({ 0: i + 1, 1: answerInfos[i].quizCode });
  }
  return rows;
};

export const setAnswerStyle = (workSheet: Excel.Worksheet, cells: string[]) => {
  cells.forEach((value) => {
    workSheet.getCell(value).border = {
      top: { style: 'thin', color: { argb: 'FFFF0000' } },
      right: { style: 'thin', color: { argb: 'FFFF0000' } },
      bottom: { style: 'thin', color: { argb: 'FFFF0000' } },
      left: { style: 'thin', color: { argb: 'FFFF0000' } },
    };
  });
};

export const readAnswerExcel = async (
  file: File,
): Promise<IAnswerExcelData[]> => {
  const value1 = '번호';
  const value2 = '퀴즈코드';
  const value3 = '학생답안';
  const workbook = await readExcel(file);
  const worksheet = workbook.getWorksheet(1);
  let last = false;
  let index = 3;
  const result: IAnswerExcelData[] = [];
  while (!last) {
    if (
      worksheet?.getCell(`A${index}`).value === value1 &&
      worksheet?.getCell(`B${index}`).value === value2 &&
      worksheet?.getCell(`C${index}`).value === value3
    ) {
      let innerLast = false;
      let innerIndex = 1;
      const body: IExamCheckAnswerCardBody[] = [];
      while (!innerLast) {
        const quizCode = Number(
          worksheet?.getCell(`B${index + innerIndex}`).value,
        );
        if (isNaN(quizCode) || quizCode === 0) {
          innerLast = true;
        } else {
          body.push({
            quizCode,
            userAnswer: worksheet?.getCell(`C${index + innerIndex}`)
              .value as string,
          });
          innerIndex++;
        }
      }
      result.push({
        examSubjectCode: Number(worksheet?.getCell(`D${index - 1}`).value),
        body,
      });
      index = innerIndex + 1 + index;
    } else {
      last = true;
    }
  }
  return result;
};
